import { Component } from "react";
import { compose } from "redux";

// markup
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import InfoTile from "./Info.Tile";
import { numberWithSpaces } from "../../../utilities/formaters";

import { statisticsConnector } from "../../../services/statistics/connector";

class DashboardStatisticsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let chartOverlay = {
      width: "100%",
      height: "100%",
      zIndex: "999",
      position: "absolute",
      backgroundColor: "rgba(207, 207, 207, 0.73)",
      top: 0,
      left: 0,
    };

    chartOverlay.display =
      !this.props.statistics.calculated || this.props.statistics.fetching
        ? "block"
        : "none";
    let stats = this.props.statistics.statistics;

    return this.props.statistics.calculated ? (
      <div
        className="dashboard-layout body-height"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ width: "100%", padding: "8px 16px" }}>
          <Card>
            <CardHeader title="Applications" />
            <CardContent style={{ display: "flex", flexWrap: "wrap" }}>
              <InfoTile
                topText={stats.newApplications.short + " Short term"}
                midleText={stats.newApplications.long + " Long term"}
                bottomText="Applications"
              />
              <InfoTile
                topText={stats.approvedAppShort.number}
                midleText={
                  numberWithSpaces(stats.approvedAppShort.amount) + " kr"
                }
                bottomText="Approved Short Term"
              />
              <InfoTile
                topText={stats.approvedAppLong.number}
                midleText={
                  numberWithSpaces(stats.approvedAppLong.amount) + " kr"
                }
                bottomText="Approved Long Term"
              />
              <InfoTile
                topText={stats.paydOut.number + " Pay outs"}
                midleText={numberWithSpaces(stats.paydOut.amount) + " kr"}
                bottomText="Payd out"
              />
              <InfoTile
                topText="Not implemented"
                midleText="(0 kr)"
                bottomText="From new borrowers"
              />
              <InfoTile
                topText="Not implemented"
                midleText="(0 kr)"
                bottomText="From existing borrowers"
              />
            </CardContent>
          </Card>
        </div>
        <div style={{ width: "100%", padding: "8px 16px" }}>
          <Card>
            <CardHeader title="Borower" />
            <CardContent style={{ display: "flex", flexWrap: "wrap" }}>
              <InfoTile topText="Not implemented" bottomText="New Loanstep" />
              <InfoTile topText={stats.loanstepLogins} bottomText="Log ins" />
              <InfoTile
                topText={numberWithSpaces(stats.payments.principal) + " kr"}
                bottomText="Amortisation"
              />
              <InfoTile
                topText={numberWithSpaces(stats.payments.intrest) + " kr"}
                bottomText="Interest"
              />
              <InfoTile
                topText={numberWithSpaces(stats.payments.fees) + " kr"}
                bottomText="Fees"
              />
            </CardContent>
          </Card>
        </div>
        <div style={{ width: "100%", padding: "8px 16px" }}>
          <Card>
            <CardHeader title="Lender" />
            <CardContent style={{ display: "flex", flexWrap: "wrap" }}>
              <InfoTile topText="Not implemented" bottomText="New Lenders" />
              <InfoTile
                topText={stats.deposits.number + " Deposits"}
                bottomText={numberWithSpaces(stats.deposits.amount) + " kr"}
              />
              <InfoTile
                topText={stats.withdrawals.number + " Withdrawals"}
                bottomText={numberWithSpaces(stats.withdrawals.amount) + " kr"}
              />
              <InfoTile
                topText={numberWithSpaces(stats.accTax) + " kr"}
                bottomText="Acc Tax"
              />
              <InfoTile
                topText={numberWithSpaces(stats.lenderFees) + " kr"}
                bottomText="Lender Fees"
              />
              <InfoTile topText={stats.savelendLogins} bottomText="Log ins" />
            </CardContent>
          </Card>
        </div>
        <div style={{ width: "100%", padding: "8px 16px" }}>
          <Card>
            <CardHeader title="Other" />
            <CardContent style={{ display: "flex", flexWrap: "wrap" }}>
              <InfoTile
                topText="Not implemented"
                bottomText="Client Account Balance"
                width="50%"
              />
              <InfoTile
                topText="Not implemented"
                bottomText="Outstanding Claim"
                width="50%"
              />
            </CardContent>
          </Card>
        </div>
      </div>
    ) : (
      <div
        style={{ position: "relative", padding: "8px 16px", height: "200px" }}
      >
        <Card>
          <CardContent>
            <div style={chartOverlay}>
              <CircularProgress size={120} thickness={8} />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}
export const StatisticsCurrent = compose(statisticsConnector)(
  DashboardStatisticsComponent,
);
